<template>
  <div>
    <primary-title>攜出名單申請作業</primary-title>
    <base-box title="查詢條件">
      <v-container grid-list-md>
        <v-layout row
                  wrap
                  class="form">
          <v-flex sm6>
            <sub-header><template v-slot:title>申請日期</template></sub-header>
            <v-layout row
                      wrap
                      class="form">
              <v-flex xs6>
                <v-menu v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width>
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="startDate"
                                  readonly
                                  placeholder="起"
                                  outline
                                  v-on="on"
                                  clearable
                                  class="date-picker-input">
                      <template v-slot:append>
                        <v-fade-transition leave-absolute>
                          <img width="24"
                               height="24"
                               @click="menu = true"
                               src="@/assets/icon_calendar.svg"
                               alt="calendar">
                        </v-fade-transition>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="startDate"
                                 no-title
                                 :header-date-format="headerFormatDates"
                                 :max="endDate"
                                 @input="menu = false">
                                </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <v-menu v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width>
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="endDate"
                                  append-icon="event"
                                  readonly
                                  placeholder="迄"
                                  outline
                                  clearable
                                  class="date-picker-input"
                                  v-on="on">
                      <template v-slot:append>
                        <v-fade-transition leave-absolute>
                          <img width="24"
                               height="24"
                               @click="menu1 = true"
                               src="@/assets/icon_calendar.svg"
                               alt="calendar">
                        </v-fade-transition>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="endDate"
                                 no-title
                                 :header-date-format="headerFormatDates"
                                 :min="startDate"
                                 :max="new Date().toISOString().substr(0, 10)"
                                 @input="menu1 = false">
                                </v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </base-box>
    <base-btn>
      <btn-lg-secondary @click="query">查詢</btn-lg-secondary>
      <btn-lg-primary @click="addHandler">新增攜出名單</btn-lg-primary>
    </base-btn>

    <base-container has-title
                    title="已申請清單"
                    v-if="showSearchResult"
                    style="padding-top:10px">
      <v-data-table :headers="headers"
                    :items="searchResult"
                    :pagination.sync="pagination"
                    :rows-per-page-items="[5,10,15,25,50] "
                    rows-per-page-text="顯示資料筆數"
                    no-data-text="查無資料可顯示"
                    class="elevation-1">
        <template v-slot:headers="props">
          <th v-for="header in props.headers"
              :key="header.value"
              :class="['column', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'sortable active' : '']"
              @click="headerHandler(header.value)">
              <v-icon v-if="sortItems.includes(header.value)"
                    small>arrow_upward</v-icon>
            <span v-html="header.text"></span>
          </th>
        </template>
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-center">{{ props.item.createDtStr }}</td>
            <td class="text-xs-center">{{ props.item.cusIdn }}</td>
            <td class="text-xs-center">{{ props.item.cusName }}</td>
            <td class="text-xs-center">{{ props.item.walkOutStartDtStr }} ~ {{ props.item.walkOutEndDtStr }}</td>
            <td class="text-xs-center">
              <span v-if="props.item.status === 'R'">
                <a href="#" @click="showReasonClick(props.item)">{{ props.item.statusName }}</a>
              </span><span v-else>{{ props.item.statusName }}</span>
            </td>
            <td class="text-xs-center">{{ props.item.applyDesc }}</td>
          </tr>
        </template>
      </v-data-table>
    </base-container>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import {  datepickerFormat } from '@/mixin'
const { mapActions } = createNamespacedHelpers('ins')
export default {
  name: 'release-permit-audit',
  mixins: [datepickerFormat],
  props: {},
  data () {
    return {
      startDate: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      menu: false,
      menu1: false,
      searchResult: [],
      showSearchResult: false,
      headers: [
        { text: '申請日期', align: 'center', value: 'createDtStr', sortable: true,  width: '4%' },
        { text: '客戶ID', align: 'center', value: 'cusIdn', sortable: true, width: '10%' },
        { text: '客戶姓名', align: 'center', value: 'cusName', sortable: true,  width: '4%' },
        { text: '攜出日期起迄', align: 'center', value: 'walkOutStartDtStr', sortable: true,  width: '4%' },
        { text: '審核狀態', align: 'center', value: 'statusName', sortable: false,  width: '4%' },
        { text: '申請說明', align: 'center', value: 'applyDesc', sortable: false,  width: '4%' }
      ],
      pagination: {
        sortBy: 'createDtStr',
        descending: true,
        rowsPerPage: 15
      },
      sortItems: ['createDtStr', 'cusIdn','cusName','walkOutStartDtStr','statusName','applyDesc'],
    }
  },
  filters: {
  },
  watch: {
  },
  methods: {
    ...mapActions(['queryReleasePermit']),
    addHandler () {
      this.$store.dispatch('common/postUserAccessLog', ({ progClassName: 'releasePermit_new', methodName: '新增攜出名單' }))
      this.$router.push({ name: 'releasePermitInput'})
    },
    query () { // 查詢
      let isEndDateValid = true
      if (!!this.startDate && !!this.endDate) {
        isEndDateValid = this.checkEndDateValid()
      }
      if ((!!this.startDate && !this.endDate) || (!this.startDate && !!this.endDate)) {
        this.showSearchResult = false
        this.$alert('申請日期起迄日皆需輸入')
      } else if (!isEndDateValid) {
        this.$alert('申請日期迄日不可小於起日')
      } else {
        this.showSearchResult = true
        this.$store.dispatch('common/postUserAccessLog', ({ progClassName: 'releasePermit_search', methodName: '查詢' }))
        this.queryReleasePermit({
          applyStartDt: this.startDate,
          applyEndDt: this.endDate,
          woType: '0'
        }).then(r => {
          if (r.data.length > 0) {
            this.searchResult = r.data
          } else {
            this.$alert('沒有資料可顯示！')
            this.searchResult = []
          }
        })
      }
    },
    checkEndDateValid () {
      return Date.parse(this.endDate) >= Date.parse(this.startDate)
    },
    headerHandler (column) { // 排序
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    showReasonClick (item) {
      if (item && item.returnDesc) {
        this.$alert('退件原因： ' + item.returnDesc)
      }
    }
  },
  created () {
  }
}
</script>
